import { render, staticRenderFns } from "./IframePreview.vue?vue&type=template&id=0421df40"
import script from "./IframePreview.vue?vue&type=script&lang=js"
export * from "./IframePreview.vue?vue&type=script&lang=js"
import style0 from "./IframePreview.vue?vue&type=style&index=0&id=0421df40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports